import { combineReducers } from '@reduxjs/toolkit';

import packReducer from './pack.slice';
import detailsReducer from './details.slice';

export default combineReducers({
  pack: packReducer,
  details: detailsReducer,
});
